import { apiType } from "./apiType";
import { IApplicantDetails, IApplicantUpdatePayload } from "@/src/types/applicant";

export const applicantsRequests = {
  getById: async (applicantId: number): Promise<IApplicantDetails | null> => {
    try {
      const response = await apiType.main.get<IApplicantDetails>(`/applicants/${applicantId}`);
      console.log(`[applicants/getById] applicant_id=${applicantId}`, response);
      return response;
    } catch (error) {
      console.log("This is applicants getById error:", error);
      return null;
    }
  },
  update: async (applicantId: number, data: IApplicantUpdatePayload) => {
    try {
      return await apiType.main.put(`/applicants/${applicantId}`, data);
    } catch (error) {
      console.log("This is applicants update error:", error);
      return null;
    }
  },
};
